import { IoCallOutline, IoMailOutline, IoLocationOutline } from "react-icons/io5";
import ContactImage from "../assets/images/contact.jpg"; // Ajusta esta ruta según tu proyecto
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const { t } = useTranslation();
  return (
    <section id="contact" className="relative w-full py-2 2xl:py-10 scroll-mt-16">
      {/* Imagen de fondo: Solo visible en pantallas grandes */}
      <img
        src={ContactImage}
        alt="Cleaning"
        className="hidden xl:block object-cover w-full h-[400px] lg:h-[550px] 2xl:h-[700px]"
      />

      {/* Contenedor de información de contacto */}
      <div className="xl:absolute lg:inset-0 flex items-center justify-center 2xl:justify-start">


        <div className="bg-bgPrimary lg:bg-white bg-opacity-100 lg:bg-opacity-80 p-6 xl:p-8 rounded-xl shadow-lg w-[90%] max-w-[380px] mx-auto xl:mx-48 relative">
          <h2 className="text-[22px] lg:text-[32px] font-bold text-white lg:text-textTitle mb-4 text-center lg:text-center">{t("contact.contact-title")}</h2>
          <p className="text-gray-100 lg:text-textTipic mb-6 text-[12px] 2xl:text-[12px] text-justify lg:text-left">{t("contact.contact-description")}
          </p>

          <div className="space-y-4 lg:space-y-4 mb-6 ">
            <div className="flex items-center justify-left  space-x-2 text-gray-100 lg:text-textTipic text-[12px] lg:text-[14px]">
              <IoCallOutline className="w-5 h-5 text-white lg:text-blue-600" />
              <span>  {t("contact.phone")} 617-777-6772 and 617-777-1348</span>
            </div>
            <div className="flex items-center justify-left  space-x-2 text-gray-100 lg:text-textTipic text-[12px] lg:text-[14px]">
              <IoMailOutline className="w-5 h-5 text-white lg:text-blue-600" />
              <span>{t("contact.email")}Gobies@gmail.com</span>
            </div>
            <div className="flex items-center justify-left  space-x-2 text-gray-100 lg:text-textTipic text-[12px] lg:text-[14px]">
              <IoLocationOutline className="w-5 h-5 text-white lg:text-blue-600" />
              <span>{t("contact.location")}  Boston - Massachusetts</span>
            </div>
          </div>

          <form>
            <textarea
              className="w-full p-2 lg:p-4 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 resize-none"
              rows={2}
              placeholder={t("contact.write-message")} 
            ></textarea>
            <button className="w-full mt-2 lg:mt-4 bg-bgWarning lg:bg-bgPrimary lg:text-white text-textLabel font-semibold py-2 lg:py-3 rounded-md hover:bg-blue-700 transition duration-300">
            {t("contact.button")} 
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
